module.exports = __webpack_public_path__ + "static/media/cartagena-35.cf1e4b73.jpg";